
















import SettingsNavigation from "@/employer/components/settings/SettingsNavigation.vue";
import MfaSettings from "@/shared/components/MfaSettings.vue";
import {
  Vue,
  Component,
} from "@/shared/vuepack";

@Component({
  components: {
    SettingsNavigation,
    MfaSettings
  }
})
export default class Security extends Vue {

}
